<template>
    <div class="normal-dialog-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="normal-content mask-content" :style="style">
            <span class="close-icon" @click="handlerClose"></span>
            <div class="title">{{ title }}</div>
            <div class="msg hide-scroll" :class="{ center: !html }">
                <template v-if="html">
                    <div v-html="msg"></div>
                </template>
                <template v-else>{{ msg }}</template>
            </div>
            <div class="op-wrap" :class="{ 'two-btn': showCancel && showConfirm }">
                <span class="cancel" @click="cancel" v-if="showCancel">{{ cancelTxt }}</span>
                <span class="confirm" @click="confirm" v-if="showConfirm">{{ confirmTxt }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NormalDialog',
    data() {
        return {
            isShow: false,
            title: '温馨提示',
            msg: '',
            style: {},
            html: false,
            cancelFn: null,
            confirmFn: null,
            showCancel: false,
            showConfirm: false,
            cancelTxt: '取消',
            confirmTxt: '确定',
            closeFn: null
        }
    },
    watch: {
        isShow: function(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('normal-dialog-page')
                })
            }
        }
    },
    methods: {
        show(option) {
            this.isShow = true
            if (option.title) {
                this.title = option.title
            }
            if (option.msg) {
                this.msg = option.msg
            }
            if (option.style && option.style instanceof Object) {
                this.style = option.style
            }
            if (option.html) {
                this.html = option.html
            }
            if (option.showCancel) {
                this.showCancel = option.showCancel
            }
            if (option.showConfirm) {
                this.showConfirm = option.showConfirm
            }
            if (option.confirmTxt) {
                this.confirmTxt = option.confirmTxt
            }
            if (option.cancelTxt) {
                this.cancelTxt = option.cancelTxt
            }
            if (option.confirmFn && option.confirmFn instanceof Function) {
                this.confirmFn = option.confirmFn
            }
            if (option.cancelFn && option.cancelFn instanceof Function) {
                this.cancelFn = option.cancelFn
            }
            if (option.closeFn && option.closeFn instanceof Function) {
                this.closeFn = option.closeFn
            }
        },
        hide() {
            this.isShow = false
            this.title = '提示'
            this.msg = ''
            this.style = {}
            this.html = false
            this.cancelFn = null
            this.confirmFn = null
            this.showCancel = false
            this.showConfirm = false
            this.cancelTxt = '取消'
            this.confirmTxt = '确定'
            this.closeFn = null
        },
        confirm() {
            this.confirmFn && this.confirmFn()
            this.hide()
        },
        cancel() {
            this.cancelFn && this.cancelFn()
            this.hide()
        },
        handlerClose() {
            this.closeFn && this.closeFn()
            this.hide()
        }
    }
}
</script>

<style lang="less" scoped>
.normal-dialog-page {
    .normal-content {
        width: 450px;
        height: 290px;
        background: @bg-color-dialog;
        padding-top: 70px;

        .title {
            text-align: center;
            font-size: 16px;
            line-height: 18px;
            color: @color-txt-high;
        }

        .msg {
            height: 100px;
            padding: 10px 50px;
            .flex-center();
            color: @color-txt-high;
            font-size: 14px;
            overflow-y: auto;
            line-height: 1.6;

            &.center {
                text-align: center;
            }
        }

        .op-wrap {
            position: absolute;
            width: 100%;
            bottom: 60px;
            left: 50%;
            padding: 0 55px;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            justify-content: center;

            &.two-btn {
                justify-content: space-between;
            }

            > span {
                .button-linear();
                width: 150px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                cursor: pointer;
            }
        }
    }
}
</style>
